import React from 'react';
import CostcoLocationTemplate from '../../components/CostcoLocationTemplate';

const NorthLakes = () => (
  <CostcoLocationTemplate
    warehouseName="North Lakes"
    suburb="North Lakes"
    state="Queensland"
    stateShort="QLD"
    address="North Lakes Dr, North Lakes QLD 4509"
    path="/costco/north-lakes"
    nearbySuburbs={[
      'North Lakes',
      'Mango Hill',
      'Griffin',
      'Kallangur',
      'Dakabin',
      'Petrie',
      'Deception Bay',
      'Narangba',
      'Burpengary',
      'Kurwongbah',
    ]}
    description="Manage Your Loans is the exclusive Costco member loan partner serving the North Lakes warehouse and the Moreton Bay growth corridor. Whether you're buying your first home in one of the many new estates, refinancing an existing loan, or looking at investment opportunities in this rapidly growing region, our brokers understand the local market and can help you maximise your Costco Shop Card reward."
    localContext={[
      'Moreton Bay is one of Queensland\'s fastest-growing corridors, with new housing estates driving strong first home buyer demand across North Lakes, Griffin, and Mango Hill.',
      'Infrastructure investment including the Moreton Bay Rail Link has boosted property values and connectivity, making the area attractive for both owner-occupiers and investors.',
      'First home buyers can take advantage of the Queensland First Home Owner Grant alongside competitive rates through our Costco member lending program.',
    ]}
    faqs={[
      {
        q: 'How do I claim my Costco Shop Card reward at North Lakes?',
        a: 'Simply apply through Manage Your Loans as a Costco Executive Member. Once your loan settles, we\'ll arrange your Costco Shop Card reward. You can use it at the North Lakes warehouse or any Costco location in Australia.',
      },
      {
        q: 'What types of loans are available for Costco members near North Lakes?',
        a: 'We offer home loans, refinancing, investment property loans, car loans, personal loans, and asset finance. All eligible settled loans earn Costco Shop Card rewards for Executive Members.',
      },
      {
        q: 'Are there first home buyer benefits in the Moreton Bay region?',
        a: 'Yes. Queensland offers a First Home Owner Grant for new builds, and our brokers can help you access competitive first home buyer rates. Combined with your Costco Shop Card reward, it\'s a great time to buy in the North Lakes corridor.',
      },
      {
        q: 'Can I apply online or do I need to visit the North Lakes warehouse?',
        a: 'You can apply entirely online or by phone — there\'s no need to visit the warehouse. Our team serves all suburbs around North Lakes including Mango Hill, Griffin, Kallangur, and the wider Moreton Bay area.',
      },
    ]}
    suburbData={{
      suburb: 'North Lakes',
      medianHouse: '$750,000',
      medianUnit: '$480,000',
      daysOnMarket: '22 days',
      rentalYield: '4.0%',
      population: '24,000',
      distanceToCostco: '1 km',
    }}
    surroundingSuburbs={[
      { suburb: 'Mango Hill', medianHouse: '$780,000', medianUnit: '$500,000', daysOnMarket: '21 days' },
      { suburb: 'Griffin', medianHouse: '$720,000', medianUnit: '$470,000', daysOnMarket: '23 days' },
      { suburb: 'Kallangur', medianHouse: '$620,000', medianUnit: '$400,000', daysOnMarket: '25 days' },
      { suburb: 'Dakabin', medianHouse: '$600,000', medianUnit: '$380,000', daysOnMarket: '27 days' },
      { suburb: 'Petrie', medianHouse: '$640,000', medianUnit: '$410,000', daysOnMarket: '26 days' },
      { suburb: 'Deception Bay', medianHouse: '$580,000', medianUnit: '$370,000', daysOnMarket: '24 days' },
      { suburb: 'Narangba', medianHouse: '$700,000', medianUnit: '$450,000', daysOnMarket: '22 days' },
      { suburb: 'Burpengary', medianHouse: '$660,000', medianUnit: '$420,000', daysOnMarket: '25 days' },
      { suburb: 'Kurwongbah', medianHouse: '$750,000', medianUnit: '$480,000', daysOnMarket: '28 days' },
    ]}
  />
);

export default NorthLakes;
